import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';

export default function App() {
  const [activeSection, setActiveSection] = useState('forside');
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll Spy to update active section in Navbar (only on home page)
  useEffect(() => {
    if (location.pathname !== '/') {
      setActiveSection('');
      return;
    }

    const handleScroll = () => {
      const sections = ['forside', 'ydelser', 'om-mig', 'udtalelser', 'kontakt'];
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      for (const sectionId of sections) {
        const el = document.getElementById(sectionId);
        if (el) {
          const top = el.offsetTop;
          const height = el.offsetHeight;
          if (scrollPosition >= top && scrollPosition < top + height) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      // If we are not on the home page, navigate to home first and pass the scroll target
      navigate('/', { state: { scrollTo: id } });
      return;
    }

    const el = document.getElementById(id);
    if (el) {
      const offset = 80; // Height of the fixed header
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = el.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(id);
    }
  };

  // Handle scrolling when arriving from another page
  useEffect(() => {
    if (location.pathname === '/' && location.state?.scrollTo) {
      const id = location.state.scrollTo;
      
      // Clear state so we don't scroll again on refresh
      navigate('/', { replace: true, state: {} });
      
      // Wait a moment for the DOM to be fully ready
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const offset = 80;
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = el.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          setActiveSection(id);
        }
      }, 150);
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#F7F4F1] text-[#4A4A4A] font-sans-clean antialiased selection:bg-[#BFC8BE]/30 selection:text-[#4A4A4A]">
      {/* Navigation */}
      <Navbar activeSection={activeSection} scrollToSection={scrollToSection} />

      {/* Main Content Routes */}
      <main>
        <Routes>
          <Route path="/" element={<Home scrollToSection={scrollToSection} />} />
          <Route path="/ydelse/:slug" element={<ServiceDetail scrollToSection={scrollToSection} />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}
